import styled from "styled-components";

import { theme } from "styles/theme";

/**
 * Estilo para o componente Icon
 * Configurações dinâmicas de tamanho e cor baseadas no tema.
 */
export const StyledIcon = styled.div.withConfig({
  shouldForwardProp: (prop) => !["size", "color"].includes(prop),
})<{
  size: number;
  color: keyof typeof theme.colors | string;
}>`
  font-size: ${({ size }) => size}px;
  color: ${({ color }) => "#000"};
  transition: all 0.3s ease-in-out;
  cursor: ${({ onClick }) => (onClick ? "pointer" : "default")};
  display: flex;

  /* PARA ICONES SVG CUSTOM (via svgName) */
  /* & > svg path {
    fill: ${({ color }) =>
      theme.colors[color] || color || theme.colors.darkGray};
    stroke: ${({ color }) =>
      theme.colors[color] || color || theme.colors.darkGray};
  } */
`;
